import { flowKeysMap } from "../constants/lists";

/**
 * Remove empty values in config
 * @returns updated config
 */
export const removeEmpty = (obj) => {
    if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(key => {
            if (typeof obj[key] === 'object') {
                removeEmpty(obj[key]);
            }

            if (
                (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) ||
                obj[key] === '' ||
                (Array.isArray(obj[key]) && obj[key].length === 0)
            ) {
                delete obj[key];
            }
        });
    }
    return obj;
}

/**
 * Get config mechanic flow name
 * @param config
 * @returns mechanic
 */
export const getMechanicFlow = (config) => {
    if (!config?.flow) return;

    for (const key in flowKeysMap) {
        if (config.flow[key]) {
            return flowKeysMap[key];
        }
    }

    return Object.keys(flowKeysMap).find((key) => config.flow[key]) || undefined;
};
